<script setup lang="ts">
import { computed } from 'vue'
import type { Subject } from '@/types'

const props = defineProps<{
  subject: Subject
}>()

const KEY_FIELDS: (keyof Subject)[] = [
  'first_name',
  'last_name',
  'age',
  'gender',
  'lkp_lat',
  'lkp_lng',
  'lkp_description',
  'medical_conditions',
  'physical_description',
  'clothing_description',
  'height',
  'weight',
]

const total = KEY_FIELDS.length

const complete = computed(() =>
  KEY_FIELDS.filter((f) => {
    const v = props.subject[f]
    return v !== null && v !== undefined && v !== ''
  }).length,
)

const percent = computed(() => Math.round((complete.value / total) * 100))
</script>

<template>
  <div class="flex items-center gap-3">
    <div class="flex-1 h-0.5 bg-surface-container-highest overflow-hidden">
      <div
        class="h-full bg-primary transition-all duration-300"
        :style="{ width: `${percent}%` }"
      />
    </div>
    <span class="text-[10px] text-outline font-mono whitespace-nowrap shrink-0">
      {{ complete }}/{{ total }} FIELDS
    </span>
  </div>
</template>
